export default __webpack_public_path__ + "static/media/male-circle.png";